import { Component, Inject, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Item, Quotation } from 'src/app/pages/dashboards/clients/interface/data.interface';
import { ModalResolutionDiscountComponent } from '../modal-resolution-discount/modal-resolution-discount.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SalesQuoteService } from 'src/app/pages/dashboards/service/sales-quote.service';

@Component({
  selector: 'app-detail-simulation-modal',
  templateUrl: './detail-simulation-modal.component.html',
  styleUrl: './detail-simulation-modal.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*', minHeight: '100px' })),
      transition('collapsed <=> expanded', [animate('300ms cubic-bezier(0.4, 0, 0.2, 1)')]),
    ]),
  ],
})
export class DetailSimulationModalComponent {
  public dataSource: MatTableDataSource<Item> = new MatTableDataSource<Item>([]);
  public booleanFlag = true;
  public columnsToDisplay = [
    'ver',
    'productTypeName',
    'targetName',
    'beneficiary',
    'beneficiaryAddress',
    'amount',
    'price',
    'discount',
    'finalPrice',
    'period',
    'state',
    'ir',
    'rate'
  ];
  public columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  public expandedElement: Item | null = null;

  constructor(@Inject(MAT_DIALOG_DATA)public simulacion: Quotation, private dialog: MatDialog, public dialogRef: MatDialogRef<DetailSimulationModalComponent>,
  private salesQuoteService: SalesQuoteService) {}

  ngOnInit(): void {
    this.dataSource.data = this.simulacion.items;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['simulacion'] && changes['simulacion'].currentValue) {
      this.dataSource.data = this.simulacion.items;
      this.booleanFlag = false;
    }
  }


  private getSalesQuote(){
    const {id} = this.simulacion;
    this.salesQuoteService.getSalesQuoteById(id)
    .subscribe({
      next: (updatedSalesQuote) => {
        this.simulacion = {
          ...this.simulacion,
          ...updatedSalesQuote
        };
        this.dataSource.data = updatedSalesQuote.items;
      }
    })
  }

  public openRisolutionDiscount(item: Item, type: number) {
    const request =  {
      idCotizacion: this.simulacion.id,
      quotation: this.simulacion,
      item: item,
      type: type
    };
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = false;
      dialogConfig.width = '76vw';
      //dialogConfig.height = '76vh';
      dialogConfig.maxWidth = '90vw';
      dialogConfig.maxHeight = '85vh';
      dialogConfig.data = request;
      const dialogRef = this.dialog.open(ModalResolutionDiscountComponent, dialogConfig);
      dialogRef.afterClosed()
      .subscribe(res => {
        if(res) this.getSalesQuote();
        console.log(res);
      })
  }

}